(function() {
    /* Button More Articles */

    attachMoreArticlesListener();

    function attachMoreArticlesListener() {
        var btnMoreArticles = document.querySelector('.btn--more-articles');

        if (btnMoreArticles !== null) {
            btnMoreArticles.addEventListener('click', function () {
                var clickedButton = this,
                    link = clickedButton.dataset.url,
                    httpRequest = new XMLHttpRequest(),
                    blazy = new LazyLoad({
                        elements_selector: '.b-lazy',
                        use_native: true,
                        threshold: 300
                    });
                clickedButton.setAttribute('disabled', 'disabled');
                httpRequest.addEventListener('load', function () {
                    clickedButton.outerHTML = httpRequest.responseText;
                    blazy.update();
                    attachMoreArticlesListener();
                });
                httpRequest.open('GET', link, true);
                httpRequest.send();
            });
        }
    }

    /* Button Survey */

    var btnSurveySend = document.querySelector('.btn--survey-send');

    if (btnSurveySend !== null) {
        btnSurveySend.addEventListener('click', function () {
            var clickedButton = this,
                link = document.querySelector('input[name=survey]:checked').dataset.url,
                httpRequest = new XMLHttpRequest(),
                surveyResultsLink = document.querySelector('.btn-link--arrow-send').dataset.url;
            if (typeof link === "undefined") {
                var labels = clickedButton.parentElement.querySelectorAll('label .label');
                Array.from(labels).forEach(function (el) {
                    el.style.color = '#da0b14';
                });
            } else {
                clickedButton.setAttribute('disabled','disabled');
                httpRequest.addEventListener('load', function () {
                    clickedButton.parentElement.parentElement.outerHTML = httpRequest.responseText;
                    //findMaxPercentage();
                    document.querySelector('.btn-link--arrow-send').dataset.url = surveyResultsLink;
                });
                httpRequest.open('GET', link, true);
                httpRequest.send();
            }
        });
    }

    /* Survey */

    var surveyInputs = document.querySelectorAll('.survey input'),
        surveyLabels = document.querySelectorAll('.survey label .label');

    Array.from(surveyInputs).forEach(function (el) {
        el.addEventListener('change', function () {
            Array.from(surveyLabels).forEach(function (el) {
                el.style.color = '';
            });
        });
    });

    /* Button Arrow Send */

    var btnArrowSend = document.querySelector('.btn-link--arrow-send');

    if (btnArrowSend !== null) {
        btnArrowSend.addEventListener('click', function () {
            var link = this.dataset.url;
            if (typeof link === "undefined") {

            } else {
                var clickedButton = this,
                    httpRequest = new XMLHttpRequest();
                clickedButton.setAttribute('disabled', 'disabled');
                httpRequest.addEventListener('load', function () {
                    clickedButton.parentElement.parentElement.outerHTML = httpRequest.responseText;
                    findMaxPercentage();
                });
                httpRequest.open('GET', link, true);
                httpRequest.send();
            }
        });
    }

    /* Find Max Percentage */

    function findMaxPercentage() {
        var percentages = [],
            largest = 0,
            answers = document.querySelectorAll('.survey__percentage');
        Array.from(answers).forEach(function (el) {
            percentages.push(el.dataset.percentage);
        });
        largest = Math.max.apply(Math, percentages);
        Array.from(answers).forEach(function (el) {
            if( el.dataset.percentage == largest ){
                el.classList.add('survey__percentage--highest');
            }
        });
        percentages =[];
    }
})();
